// extracted by mini-css-extract-plugin
module.exports = {"root":"StoryInfoDrawer-root-a713ea81c575376ddcd310f53bc3fc79"};